import theme from "@shared/utils/themeColors";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import SidebarLinkGroup from "../SidebarLinkGroup";
import { SidebarGroupItem } from "./types";

interface SidebarGroupProps {
	item: SidebarGroupItem;
	onExpand: () => void;
}

export const SidebarGroup: React.FC<SidebarGroupProps> = ({ item, onExpand }) => {
	const location = useLocation();
	const { pathname, search } = location;
	const fullPath = pathname + search;

	const isActive = (): boolean => {
		if (item.excludedMatch) {
			const isExcluded = Array.isArray(item.excludedMatch)
				? item.excludedMatch.some((match) => fullPath.includes(match))
				: fullPath.includes(item.excludedMatch);
			if (isExcluded) return false;
		}

		if (item.pathMatch) {
			return Array.isArray(item.pathMatch)
				? item.pathMatch.some((match) => fullPath.includes(match))
				: fullPath.includes(item.pathMatch);
		}

		return item.children.some((child) => fullPath.includes(child.path));
	};

	const active = isActive();
	const icon = typeof item.icon === "function" ? item.icon(active) : item.icon;

	return (
		<SidebarLinkGroup activecondition={active} initialOpen={item.initialOpen}>
			{(handleClick, open) => (
				<React.Fragment>
					<a
						href="#0"
						className={`block ${theme.text.primary} truncate transition duration-150 ${active ? "" : "hover:text-gray-900 dark:hover:text-white"
							}`}
						onClick={(e) => {
							e.preventDefault();
							handleClick();
							onExpand();
						}}
					>
						<div className="flex items-center justify-between">
							<div className="flex items-center">
								{icon}
								<span className="text-sm font-medium ml-4 md:opacity-0 md:sidebar-expanded:opacity-100 xl:opacity-100 duration-200">
									{item.label}
								</span>
							</div>
							<div className="flex shrink-0 ml-2">
								<svg
									className={`w-3 h-3 shrink-0 ml-1 fill-current text-gray-400 dark:${theme.text.muted} ${open && "rotate-180"
										}`}
									viewBox="0 0 12 12"
								>
									<path d="M5.9 11.4L.5 6l1.4-1.4 4 4 4-4L11.3 6z" />
								</svg>
							</div>
						</div>
					</a>
					<div className="md:hidden md:sidebar-expanded:block xl:block">
						<ul className={`pl-8 mt-1 ${!open && "hidden"}`}>
							{item.children.map((child) => (
								<li key={child.id} className="mb-1 last:mb-0">
									<NavLink
										end={child.exact}
										to={child.path}
										className={({ isActive }) =>
											"block transition duration-150 truncate " +
											(isActive
												? theme.text.primary
												: "text-gray-500/90 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200")
										}
									>
										<span className="text-sm font-medium md:opacity-0 md:sidebar-expanded:opacity-100 xl:opacity-100 duration-200">
											{child.label}
										</span>
									</NavLink>
								</li>
							))}
						</ul>
					</div>
				</React.Fragment>
			)}
		</SidebarLinkGroup>
	);
};
